import React from 'react'
import Nav from '../Nav/nav';
import './SyaratDanKetentuan.css'

const SyaratDanKetentuan = () => {
    return (
        <div>
            <Nav />
            <div className="container-syaratdanketentuan">
                <div className="title-syaratdanketentuan">
                    <h1>SYARAT & KETENTUAN</h1>
                </div>
                <div className="A">
                    <h3>A. Pendahuluan</h3>
                    <p>
                        WeShare (“Kami”) merupakan platform kolaborasi yang dikembangkan oleh PT Teman Baik Sejehtera untuk memfasilitasi kegiatan
                        Yayasan WeShare Indonesia sebagai penyelenggara Pengumpulan Uang dan Barang (Charity Crowdfunding) yang telah mendapatkan izin
                        berkala dari Kementerian Sosial Republik Indonesia. Dengan mengunjungi, mengakses, mendaftar, dan memanfaatkan situs ini, maka
                        pengguna dianggap telah membaca, mengerti, memahami dan menyetujui semua isi dalam Syarat & Ketentuan. Mengacu pada peraturan
                        perundang-undangan tentang transaksi elektronik, khususnya Pasal 47 jo. Pasal 50 Peraturan Pemerintah Nomor 82 Tahun 2012 tentang
                        Penyelenggaraan Sistem dan Transaksi Elektronik, maka Ketentuan Persyaratan dan Ketentuan ini merupakan suatu kontrak elektronik, dan
                        oleh karenanya Pengguna dengan ini menyatakan menyepakati dan terikat atas setiap ketentuan yang terdapat dalam Persyaratan dan
                        Ketentuan ini selayaknya suatu perjanjian yang sah yang dibuat oleh dan antara Pengguna dengan WeShare. Jika pengguna tidak
                        menyetujui salah satu, sebagian, atau seluruh isi Syarat & Ketentuan, maka pengguna tidak diperkenankan menggunakan layanan di
                        WeSharecom.
                    </p>
                </div>
                        

                <div className="B">
                    <h3>B. Definisi</h3>
                    <ol>
                        <li>
                            <p>
                                <span>Platform WeShare</span> 
                                adalah website dan mobile web www.WeShare.com , serta aplikasi android dan IOS.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Syarat & Ketentuan </span>
                                adalah perjanjian antara Pengguna dan WeShare yang memuat seperangkat peraturan yang mengatur hak,
                                kewajiban, tanggung jawab Pengguna dan WeShare, serta tata cara penggunaan platform WeShare.com.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Penggalang Dana </span>
                                adalah proses pengumpulan kontribusi sukarela dalam bentuk uang atau sumber daya lainnya dari sumbangan individu,
                                perusahaan, organisasi, atau lembaga pemerintah untuk disalurkan kepada Penerima Manfaat yang berhak.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Organisasi </span>
                                yang dimaksud adalah Badan Hukum, Bukan Badan Hukum, dan Komunitas/Paguyuban.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Pengguna </span>
                                adalah pihak yang menggunakan layanan WeShare yang terdiri dari Penggalang Dana, Donatur, Penerima Manfaat
                                termasuk tidak terbatas pada pihak lain.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Penggalang Dana Utama (Campaigner) </span>
                                adalah individu atau organisasi yang melalukan kegiatan pengumpulan sumbangan yang akan
                                disalurkan kepada Penerima Manfaat yang berhak dan/atau Penggalang Dana tersebut secara langsung dilakukan oleh Penerima Manfaat.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Penggalang Dana Penunjang (Fundraiser) </span>
                                adalah individu atau organisasi yang menyatakan dukungan terhadap suatu penggalang dana
                                yang telah dibuat oleh Penggalang Dana Utama dengan membuat halaman kampanye baru yang selanjutnya dana yang berhasil
                                terkumpul akan masuk pada halaman kampanye Penggalang Dana Utama.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Donatur (Donors) </span>
                                adalah individu atau organisasi yang memberikan sumbangan secara sukarela kepada Penerima Manfaat melalui platform WeShare.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Penerima Manfaat (Beneficiary) </span>
                                adalah individu atau organisasi yang memperoleh sumbangan hasil dari penggalangan dana melalui platform WeShare.
                            </p>
                        </li>
                        <li>
                            <p>x
                                <span>Rekening Resmi Donasi </span>
                                adalah rekening penampungan donasi atas nama Yayasan Benih Baik Indonesia yang terverifikasi oleh Kementerian
                                Sosial Republik Indonesia. Rekening resmi donasi dapat ditemukan di halaman.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Pencairan (Disbursement) </span>
                                adalah suatu proses penyerahan donasi yang terkumpul dalam Rekening WeShare untuk selanjutnya
                                disalurkan kepada Penggalang Dana dan/atau Penerima Manfaat.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Dompet Siaga </span>
                                adalah salah satu penampungan donasi yang tidak terikat dengan program kampanye penggalangan dana tertentu dan
                                disalurkan oleh WeShare untuk kasus-kasus yang membutuhkan penanganan cepat dan sesuai diskresi WeShare.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Kurasi </span>
                                adalah serangkaian verifikasi dan validasi yang dilakukan oleh tim WeShare terhadap data dan informasi calon Penggalang
                                Dana dan/atau Penerima Manfaat.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Corporate Social Responsibility atau CSR </span>
                                adalah dana yang yang dialokasikan oleh Perusahaan untuk melaksanakan program tanggung
                                jawab sosial melalui WeShare.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Mitra Penyaluran </span>
                                adalah organisasi terpercaya yang telah bekerjasama dengan WeShare untuk membantu proses distribusi
                                sumbangan kepada Penerima Manfaat yang berhak.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Mitra Penunjang Pembayaran Donasi </span>
                                adalah Perusahaan Bank/Non Bank berizin yang menyediakan layanan pembayaran donasi berupa
                                Payment Gateway yang telah bekerjasama dengan WeShare yang tujuan memudahkan Donatur untuk melakukan pembayaran
                                donasi.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span>Mitra Penunjang Pencairan </span>
                                adalah Perusahaan Non Bank yang bergerak di bidang Transfer Dana berizin yang bekerjasama dengan
                                WeShare untuk membuat proses pencairan secara otomatis.
                            </p>
                        </li>
                    </ol>
                </div>

                <div className="C">
                    <h3>C. Ketentuan Penggalangan Dana</h3>
                    <ol>
                        <li>
                            <p>
                                Penggalang Dana dengan ini menyatakan adalah orang yang cakap dan mampu untuk mengikatkan dirinya dalam sebuah perjanjian yang
                                sah menurut hukum. Apabila Penggalang Dana dan/atau Penerima Manfaat adalah anak maka wajib diwakilkan oleh Orang Tua atau wali.
                            </p>
                        </li>
                        <li>
                            <p>
                                Sebelum membuat halaman kampanye, Penggalang Dana wajib melakukan registrasi akun dan mengisi data diri serta memberikan semua
                                data yang valid untuk kebutuhan kurasi WeShare.
                            </p>
                        </li>
                        <li>
                            <p>
                                Untuk keperluan registrasi akun, Pengguna diminta mengisi username, email pribadi aktif, dan password. Selanjutnya sistem elektronik akan
                                mengirim kode One Time Pasword kepada akun Pengguna untuk verifikasi tambahan dan verifikasi melaui email.
                            </p>
                        </li>
                        <li>
                            <p>
                                Pengguna bertanggung jawab secara pribadi untuk menjaga kerahasiaan akun dan password untuk semua aktivitas yang terjadi dalam
                                akun Pengguna.
                            </p>
                        </li>
                        <li>
                            <p>
                                Mengisi form data diri dan data penerima manfaat.
                            </p>
                        </li>
                        <li className="data-penerima-manfaat">
                            <p>
                                Adapun informasi dan dokumen softcopy yang dibutuhkan WeShare saat Penggalang Dana saat melakukan registrasi, wajib
                                melampirkan data Penerima Manfaat sebagai berikut:
                            </p>
                            <ol className="ol-c">
                                <li>
                                    <p>Individu</p>
                                    <ol>
                                        <li><p>KTP;</p></li>
                                        <li><p>NPWP (apabila ada);</p></li>
                                        <li><p>Nomor Rekening Penerima Manfat harus sama dengan KTP);</p></li>
                                        <li><p>Akte Kelahiran/Kartu Keluarga (apabila Penerima Manfaat adalah anak).</p></li>
                                        <li><p>Rekam Medis (dibutuhkan apabila penggalangan dana adalah kategori kesehatan).</p></li>
                                        <li><p>Nomor Telpon atau seluler aktif;</p></li>
                                        <li><p>Foto diri sambil memegang KTP.</p></li>
                                    </ol>
                                </li>
                                <li>
                                    <p>Organisasi Badan Hukum (Yayasan atau NGO)</p>
                                    <ol>
                                        <li><p>Akta Pendirian Organisasi (berikut anggaran dasar perubahan apabila ada);</p></li>
                                        <li><p>SK Kemenkumham;</p></li>
                                        <li><p>NPWP Badan;</p></li>
                                        <li><p>KTP Penanggung Jawab;</p></li>
                                        <li><p>Nomor Rekening atas nama Badan;</p></li>
                                        <li><p>Tanda Daftar Yayasan;</p></li>
                                        <li><p>Surat Keterangan Domisili;</p></li>
                                        <li><p>Struktur Organisasi;</p></li>
                                        <li><p>Izin Khusus (apabila ada);</p></li>
                                        <li><p>Foto diri penanggung jawab sambil memegang KTP; dan</p></li>
                                        <li><p>Surat Kuasa (apabila penanggungjawab bukan ketua Yayasan/NGO)</p></li>
                                    </ol>
                                </li>
                                <li>
                                    <p>
                                        Apabila Penggalang Dana dan/atau Penerima Manfaat adalah Komunitas/Paguyuban maka persyaratan dipersamakan dengan tipe
                                        perorangan karena bukan kategori badan hukum.
                                    </p>
                                </li>
                            </ol>  
                        </li>
                        <li className="data-penerima-manfaat">
                            <p>Penggalang Dana yang mewakili Penerima Manfaat wajib menyertakan data dan dokumen sebagai berikut:</p>
                            <ol className="ol-c">
                                <li><p>Surat Kuasa yang ditandatangani antara Penerima Manfaat dengan Penggalan Dana.</p></li>
                                <li><p>KTP Penggalang Dana.</p></li>
                                <li>
                                    <p>
                                        Foto dan/atau video yang merekam proses berlangsungnya tandatangan Surat Kuasa antara Penerima Manfaat dengan Penggalang
                                        Dana.
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li>
                            <p>
                                Nomor rekening yang wajib terdaftar pada akun penggalangan dana adalah nomor rekening Penerima Manfaat. Apabila terjadi perubahan
                                nomor rekening dari Penerima Manfaat kepada Rekening Bank bukan atas nama Penerima Manfaat, Penggalang Dana wajib menyertakan
                                Surat Kuasa penggantian akun rekening melalui layanan costumer service dan tim assesor akan melakukan verifikasi atas penggantian
                                rekening tersebut
                            </p>
                        </li>
                        <li className="data-penerima-manfaat">
                            <p>Saat membuat halaman kampanye, Penggalang Dana wajib menyampaikan keterangan yang detail sekurang-kurangnya meliputi:</p>
                            <ol className="ol-c">
                                <li><p>Tujuan dan rencana penggunaan dana;</p></li>
                                <li><p>Minimal 5 Objek foto;</p></li>
                                <li><p>Minimal 5 paragraf; dan</p></li>
                                <li><p>5W + 1H.</p></li>
                            </ol>
                        </li>
                        <li>
                            <p>
                                Saat membuat halaman kampanye, Penggalang Dana wajib menjamin fakta dan kebenaran yang dapat dipertangungjawabkan atas
                                semua data dan/atau konten baik tulisan, foto, dan video yang diunggah untuk dikampayekan kepada publik.
                            </p>
                        </li>
                        <li className="data-penerima-manfaat">
                            <p>Penggalang Dana dilarang membuat konten kampanye yang terindikasi:</p>
                            <ol className="ol-c">
                                <li><p>Menyebarkan kebohongan dan informasi menyesatkan yang dapat merugikan orang lain;</p></li>
                                <li><p>Menyebarkan spam termasuk konten-konten promosi dan marketing di luar isi dan materi yang diperbolehkan oleh WeShare;</p></li>
                                <li><p>Mendukung kegiatan terorisme, menebar kebencian, kekerasan, pelecehan, bullying, diskriminasi, atau intoleransi berkaitan dengan SARA;</p></li>
                                <li><p>Perdagangan manusia, ekploitasi manusia dan suap;</p></li>
                                <li><p>Pornografi, konten dewasa dan mengandung unsur seksualitas;</p></li>
                                <li><p>Menggalang dana tanpa seizin Penerima Manfaat;</p></li>
                                <li><p>Menggalang Dana untuk pinjaman atau pelunasan utang;</p></li>
                                <li><p>Menggalang dana yang tidak memiliki muatan sosial dan kemanusiaan dengan pengertian untuk kesenangan pribadi semata;</p></li>
                                <li><p>Bermuatan politik praktis; dan</p></li>
                                <li><p>Bertentangan dengan ketertiban umum, kesusilaan, dan peraturan-perundang- undangan yang berlaku.</p></li>
                            </ol>
                        </li>
                        <li>
                            <p>
                                Penggalang Dana dilarang keras mencatumkan nomor Rekening pada halaman kampanye yang dapat dilihat oleh umum dan hanya boleh
                                tercantum pada akun Penggalang Dana. WeShare berhak menurunkan dan menghaspus deksripsi cerita apabila menemukan
                                pencantuman nomor rekening dalam halaman kampanye Penggalangan Dana.
                            </p>
                        </li>
                        <li>
                            <p>
                                Penggalang Dana bertanggung jawab penuh atas kesuksesan pengumpulan donasI dengan mempromosikan kampanye yang telah dibuat,
                                penggunaan donasi, serta pelaporan sebagaimana diatur dalam Syarat dan Ketentuan ini.
                            </p>
                        </li>
                        <li>
                            <p>
                                WeShare memiliki kewenangan untuk menutup akun Pengguna baik sementara maupun permanen serta menunda akun apabila
                                terindikasi adanya tindakan kecurangan dan penipuan, serta pelanggaran terhadap Syarat dan Ketentuan WeShare. Pengguna menyetujui
                                bahwa WeShare berhak melakukan tindakan lain yang diperlukan terkait hal tersebut, termasuk namun tidak terbatas pada menolak
                                pengajuan Penggalangan Dana.
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    )
}

export default SyaratDanKetentuan
